import React from 'react';
import { Box, HStack, Icon, Link, Text } from '@chakra-ui/react';
import { MdEmail, MdLocationOn, MdLockOutline, MdPhone } from 'react-icons/md';
import { FaInstagram } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import Container from '../ui/Container';
import site from '../../config/site';

export default function TopBar() {
  return (
    <Box bg="brand.900" color="whiteAlpha.900" fontSize="xs" py={2}>
      <Container>
        <HStack justify="space-between" spacing={4}>
          <HStack spacing={{ base: 3, md: 6 }} overflow="hidden">
            <Link href={site.phone.href} display="flex" alignItems="center" gap={1.5}>
              <Icon as={MdPhone} aria-hidden="true" />
              <Text as="span">{site.phone.label}</Text>
            </Link>
            <Link
              href={site.email.href}
              display={{ base: 'none', md: 'flex' }}
              alignItems="center"
              gap={1.5}
            >
              <Icon as={MdEmail} aria-hidden="true" />
              <Text as="span">{site.email.label}</Text>
            </Link>
            <HStack
              display={{ base: 'none', lg: 'flex' }}
              spacing={1.5}
              aria-hidden="true"
            >
              <Icon as={MdLocationOn} />
              <Text as="span">{site.location.short}</Text>
            </HStack>
          </HStack>
          <HStack spacing={1}>
            <Link
              as={RouterLink}
              to="/admin/login"
              aria-label="Acceso administrativo"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minW="44px"
              minH="44px"
              _focusVisible={{ outline: '2px solid', outlineColor: 'white' }}
            >
              <Icon as={MdLockOutline} boxSize={4} />
            </Link>
            <Link
              href={site.social.instagram.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SIESA en Instagram"
              display="flex"
              alignItems="center"
              minW="44px"
              minH="44px"
              justifyContent="center"
              _focusVisible={{ outline: '2px solid', outlineColor: 'white' }}
            >
              <Icon as={FaInstagram} boxSize={4} />
            </Link>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
}
